import {ScoutingNote} from "../types/scoutingNote";
import {handleAxiosError} from "./axiosErrorHandler";
import apiClient from "./baseService";

export const getScoutingNotes = async (companyId: string, fieldId: string) => {
    return apiClient
        .get<Promise<ScoutingNote[]>>(`/companies/${companyId}/fields/${fieldId}/scouting-notes`)
        .then((response) => response.data)
        .catch(handleAxiosError);
};

export const getScoutingNoteDetails = async (companyId: string, fieldId: string, noteId: string) => {
    return apiClient
        .get<Promise<ScoutingNote>>(`/companies/${companyId}/fields/${fieldId}/scouting-notes/${noteId}`)
        .then((response) => response.data)
        .catch(handleAxiosError);
};

export const downloadScoutingNotePDF = async (
    companyId: string,
    fieldId: string,
    noteId: string,
    scoutingMapData: string,
    translations: Record<string, string>,
) => {
    try {
        const binaryData = atob(scoutingMapData.split(",")[1]);
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uintArray = new Uint8Array(arrayBuffer);

        for (let i = 0; i < binaryData.length; i++) {
            uintArray[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([arrayBuffer], {type: "image/png"});
        const formData = new FormData();

        formData.append("scoutingMapData", blob, "scoutingMap.png");
        formData.append("translations", JSON.stringify(translations));

        const response = await apiClient.post(
            `/companies/${companyId}/fields/${fieldId}/scouting-notes/${noteId}/pdf`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                responseType: "blob",
            },
        );

        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = fileURL;
        link.setAttribute("download", "scouting-note.pdf");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        console.error("Error downloading PDF:", error);
    }
};

export const downloadScoutingNoteZIP = async (companyId: string, fieldId: string, noteId: string) => {
    try {
        const response = await apiClient.get(`/companies/${companyId}/fields/${fieldId}/scouting-notes/${noteId}/zip`, {
            responseType: "blob",
        });

        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = fileURL;
        link.setAttribute("download", "scouting-note.zip");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        console.error("Error downloading ZIP:", error);
    }
};
